import React from 'react';
import PropTypes from 'prop-types';

const Registered = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <g stroke={color} clipPath="url(#a)">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M9.774 13.191v2.586L4.935 17.5C3.775 17.883 3 19.032 3 20.18V22h12.5m1-5.5-1.887-.723V13"
      />
      <path
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M11.9 13.8c2.762 0 5-2.686 5-6s-2.238-6-5-6c-2.761 0-5 2.686-5 6s2.239 6 5 6Z"
      />
      <path
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M16.8 7.2h-.5c-1.7.3-2.8-.3-3.7-1.9-.6 1.1-2.3 1.9-3.8 1.9-.7 0-1.3-.1-1.9-.5"
      />
      <path strokeLinecap="round" d="M16 19.5h7M19.5 16v7" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

Registered.propTypes = {
  color: PropTypes.string
};

export default Registered;
